'use client';

import _regeneratorRuntime from "@babel/runtime/helpers/esm/regeneratorRuntime";
import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import { useEffect } from 'react';
import useSWR from 'swr';
import { getUserInfo, requestLogout } from "../services/UserController";
import { popupCenter } from "../utils/popcenter";
function useUser(_ref) {
  var apiDomain = _ref.apiDomain,
    _ref$webDomain = _ref.webDomain,
    webDomain = _ref$webDomain === void 0 ? 'https://petercat.ai' : _ref$webDomain,
    fingerprint = _ref.fingerprint;
  var _useSWR = useSWR(['user.info'], /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            return _context.abrupt("return", getUserInfo(apiDomain, {
              clientId: fingerprint
            }));
          case 1:
          case "end":
            return _context.stop();
        }
      }, _callee);
    })), {
      suspense: false
    }),
    user = _useSWR.data,
    isLoading = _useSWR.isLoading,
    mutate = _useSWR.mutate;
  var doLogin = function doLogin() {
    console.log('call do Login', webDomain);
    popupCenter({
      url: "".concat(webDomain, "/user/login"),
      title: 'Login',
      w: 600,
      h: 400
    });
  };
  var handleLoginPostMessage = function handleLoginPostMessage(event) {
    var origin = event.origin,
      data = event.data;
    var status = data.status;
    if (status === 'success' && (origin === webDomain || origin === location.origin)) {
      mutate();
    }
  };
  useEffect(function () {
    if (typeof window === 'undefined') {
      return;
    }
    window.addEventListener('message', handleLoginPostMessage);
    return function () {
      window.removeEventListener('message', handleLoginPostMessage);
    };
  }, []);
  var doLogout = /*#__PURE__*/function () {
    var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
      return _regeneratorRuntime().wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            _context2.next = 2;
            return requestLogout(apiDomain);
          case 2:
            mutate();
          case 3:
          case "end":
            return _context2.stop();
        }
      }, _callee2);
    }));
    return function doLogout() {
      return _ref3.apply(this, arguments);
    };
  }();
  return {
    user: user,
    isLoading: isLoading,
    actions: {
      doLogin: doLogin,
      doLogout: doLogout
    }
  };
}
export default useUser;